import { render, staticRenderFns } from "./DashboardOffers.vue?vue&type=template&id=6964bcee&"
import script from "./DashboardOffers.vue?vue&type=script&lang=js&"
export * from "./DashboardOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports